<template>
  <div
    class="p-0"
    style="position: relative"
    v-click-outside="handleCloseFilters"
  >
    <div
      class="filter-icon-wrapper"
      @click="() => (isUnwrapped = !isUnwrapped)"
    >
      <img src="../../icons/dod/dodFilterIcon.svg" alt="Filter icon" />
    </div>
    <aside
      v-if="isUnwrapped"
      class="filters-aside-wrapper"
      :key="customKey"
      :style="`${right ? `right: ${right}px` : ''} ${
        top ? `top: ${top}px` : ''
      }`"
    >
      <strong class="filters-header">Filtry</strong>
      <div class="flex p-0" style="gap: 10px">
        <custom-button
          title="Wyczyść"
          :gray="true"
          :size="'small'"
          @click="() => handleClearFilters()"
        />
        <custom-button
          title="Potwierdź"
          :gradient="true"
          :size="'small'"
          @click="() => parseFiltersAndEmit()"
        />
      </div>
      <DodFiltersCheckboxes
        v-if="settings.includes('DEPARTMENT')"
        title="Wydział"
        :options="dodDepartments.data"
        @onClick="(val) => handleSetCheckboxesArray('departmentsIds', val)"
      />
      <DodFiltersCheckboxes
        v-if="settings.includes('TASK_CATEGORY')"
        title="Kategoria zadania"
        :options="tasksCategories.data"
        @onClick="(val) => handleSetCheckboxesArray('categoriesIds', val)"
      />

      <DodFiltersCheckboxes
        v-if="settings.includes('CUSTOMER_STATUS')"
        title="Status Podopiecznego"
        :options="customerStatuses"
        @onClick="
          (val) => handleSetCheckboxesArray('customersStatusesIds', val)
        "
      />
      <DodFiltersCheckboxes
        v-if="settings.includes('EMPLOYEE_STATUS')"
        title="Status Opiekuna"
        :options="employeeStatuses"
        @onClick="
          (val) => handleSetCheckboxesArray('employeesStatusesIds', val)
        "
      />
      <DodFiltersCheckboxes
        v-if="settings.includes('PRIORITY_STATUS')"
        title="Priorytet"
        :options="dodPriorities.data"
        @onClick="(val) => handleSetCheckboxesArray('prioritiesIds', val)"
      />
      <DodFiltersCheckboxes
        v-if="settings.includes('SCOPE_OF_CARE')"
        title="Zakres opieki"
        :options="dodScopesOfCare.data"
        @onClick="(val) => handleSetCheckboxesArray('scopesOfCareIds', val)"
      />

      <DodFiltersCheckboxes
        v-if="settings.includes('TASK_ASSIGNMENT')"
        title="Przypisane do"
        :options="adminsList"
        @onClick="(val) => handleSetCheckboxesArray('admins', val)"
      />

      <DodFiltersCheckboxes
        v-if="settings.includes('SETTLEMENT_STATUS')"
        title="Status rozliczenia"
        :options="settlementStatusOptions"
        @onClick="(val) => handleSetCheckboxesArray('settlementStatuses', val)"
      />
    </aside>
  </div>
</template>

<script>
import CustomButton from "../CustomButton.vue";
import DodFiltersCheckboxes from "./DodFiltersCheckboxes.vue";
export default {
  components: {
    CustomButton,
    DodFiltersCheckboxes,
  },
  props: {
    settings: {
      type: Array,
      default: () => [],
    },
    top: {
      type: Number,
      default: 0,
    },
    right: {
      type: Number,
      default: 0,
    },
    customKey: new Date().getTime(),
  },
  emits: ["onFilter"],
  data() {
    return {
      filterMap: new Map(),
      isUnwrapped: false,
      tempEMPLOYEE_STATUS: [
        {
          id: "fgodf",
          name: "test1",
        },
        {
          id: "fgodfsdfsd",
          name: "test2",
        },
      ],
      tempCUSTOMER_STATUS: [
        {
          id: "fgodfsdfdsfdsfsdfas",
          name: "test1",
        },
        {
          id: "fgodfsdfsdsdfsdfds",
          name: "test2",
        },
      ],
      tempTASK_CATEGORY: [
        {
          id: "fgodfsdfdsfdsfsdfas",
          value: "fgodfsdfdsfdsfsdfas",
          name: "test1",
          shortName: "test1",
        },
        {
          id: "fgodfsdfsdsdfsdfds",
          value: "fgodfsdfsdsdfsdfds",
          name: "test2",
          shortName: "test2",
        },
      ],
    };
  },
  async created() {
    // fetch assets to filters if are unavailable
    if (
      this.settings?.includes("DEPARTMENT") &&
      !this.$store.getters.getDodDepartments?.length
    ) {
      await this.$store.dispatch("getDodDepartments");
    }
    if (
      this.settings?.includes("SCOPE_OF_CARE") &&
      !this.$store.getters.getDodScopesOfCare?.length
    ) {
      await this.$store.dispatch("getDodScopesOfCare");
    }
    if (
      this.settings?.includes("PRIORITY_STATUS") &&
      !this.$store.getters.getDodPriorities?.length
    ) {
      await this.$store.dispatch("getDodPriorities");
    }
    if (
      this.settings?.includes("TASK_CATEGORY") &&
      !this.$store.getters.tasksCategories?.length
    ) {
      await this.$store.dispatch("getDodTasksCategories");
    }
    if (
      this.settings?.includes("CUSTOMER_STATUS") &&
      !this.customerStatuses?.length
    ) {
      await this.$store.dispatch("fetchCustomerStatuses");
    }
    if (
      this.settings?.includes("EMPLOYEE_STATUS") &&
      !this.employeeStatuses?.length
    ) {
      await this.$store.dispatch("fetchEmployeeStatuses");
    }

    this.buildEmptyFiltersObject();
  },
  methods: {
    buildEmptyFiltersObject() {
      this.filterMap.clear();
      if (this.settings?.length) {
        this.settings.forEach((setting) => {
          this.filterMap.set(`${setting}`, []);
        });
      }
    },
    handleCloseFilters() {
      this.isUnwrapped = false;
    },
    // parseKeyToCamelCaseWithIds(str) {
    //   const words = str.split("_");
    //   const convertedWords = words.map((word, index) => {
    //     if (index === 0) {
    //       return word.toLowerCase();
    //     } else {
    //       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    //     }
    //   });
    //   return convertedWords.join("") + "Ids";
    // },
    parseFiltersAndEmit() {
      const filtersToEmit = [];
      this.filterMap.forEach((value, key) => {
        const valueToSet = value.reduce(
          (finalString, filter) => (finalString += `${filter.id},`),
          ""
        );
        if (valueToSet) {
          filtersToEmit.push({
            key: key,
            value: valueToSet,
          });
        }
      });
      this.$emit("onFilter", filtersToEmit);
    },
    handlePickFilter(key, value) {
      if (this.filterMap.has(key) && this.filterMap.get(key).includes(value)) {
        this.filterMap.set(
          `${key}`,
          this.filterMap.get(key).filter((val) => val !== value)
        );
      } else {
        this.filterMap.set(`${key}`, value);
      }
    },
    handleSetCheckboxesArray(key, value) {
      this.filterMap.set(key, value);
    },
    handleClearFilters() {
      this.customKey = new Date().getTime();
      this.buildEmptyFiltersObject();
      this.parseFiltersAndEmit();
    },
  },
  computed: {
    dodDepartments() {
      return this.$store.getters.getDodDepartments;
    },
    dodScopesOfCare() {
      return this.$store.getters.getDodScopesOfCare;
    },
    dodPriorities() {
      return this.$store.getters.getDodPriorities;
    },
    tasksCategories() {
      return this.$store.getters.getDodTasksCategories;
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    adminsList() {
      return (this.$store.getters.getDodAdminsList && this.$store.getters.getDodAdminsList.data || []).map((admin) => {
        return {
          id: admin.phone,
          name: admin.phone,
        };
      });
    },
    settlementStatusOptions() {
      return [
        { id: "NIEROZLICZONO", name: "NIEROZLICZONO" },
        { id: "W_TRAKCIE", name: "W TRAKCIE" },
        { id: "DO_WERYFIKACJI", name: "DO WERYFIKACJI" },
        { id: "DO_POPRAWY", name: "DO POPRAWY" },
        { id: "ROZLICZONO", name: "ROZLICZONO" },
      ];
    },
  },
};
</script>

<style scoped>
.filter-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  border: 0.5px solid rgb(9, 7, 65, 0.25);
  height: 44px;
  width: 44px;
  cursor: pointer;
}
.filter-icon-wrapper:hover {
  background: rgb(226, 226, 226);
}
.filters-aside-wrapper {
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 2000;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
}
.filters-header {
  font-size: 14px;
  color: #090741;
}
.input-label {
  color: #090741;
  font-size: 12px;
  font-weight: 700;
  padding-left: 5px;
  margin-bottom: 0;
  margin-top: 10px;
}
</style>
